// 检查管理员是否有相应的 bkey 权限
import constants from "@/constants"

export default (Vue) => {
  // 管理权限
  Vue.directive('hasBKeyPermission', {
    inserted: (el, bindings) => {
      const bKeyListString = localStorage.getItem('bKeyList')
      const bKeyListArray = bKeyListString ? bKeyListString.split(',') : []

      const { value } = bindings
      const flag = value.some((bKey) => {
        const fullBKey = constants.MANAGE_BKEY_LIST_CONFIG[bKey]
        return fullBKey ? bKeyListArray.includes(fullBKey) : false
      })
      if (!flag) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })

  // 市场地区权限
  Vue.directive('hasMarketPermission', {
    inserted: (el, bindings) => {
      const manageMarketList = localStorage.getItem('manageMarketList') || []

      const { value } = bindings
      const flag = value.some((market) => {
        return manageMarketList.includes(market.toLowerCase())
      })
      if (!flag) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  })
}
